import React from 'react'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { ApolloProvider } from '@apollo/client'
import Routes from './Routes'
import { apolloClient } from 'config/apollo'
import theme from 'config/theme'

import TagManager from 'react-gtm-module'
import { ToastContainer } from 'react-toastify'

const tagManagerArgs = {
  gtmId: 'GTM-MB2VLK6X',
}

TagManager.initialize(tagManagerArgs)

function App(): JSX.Element {
  return (
    <>
      <ThemeProvider theme={theme}>
        <div className="App">
          <ApolloProvider client={apolloClient}>
            <CssBaseline />
            <Routes />
          </ApolloProvider>
        </div>
      </ThemeProvider>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  )
}

export default App
